import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import moment from 'moment'
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import _ from 'lodash';

// COMPONENT
import * as styled from '../style/main.style'
import Navbar from '../Navbar'
import Header from '../Header'
import InputDatePicker from '../../../component/input/inputDatePicker'
import InputTextField from '../../../component/input/inputTextField'
import { Typography } from '@mui/material'
import { ButtonOutlined, ButtonContained, ButtonOutlinedDanger } from '../../../component/mui-custom/MuiCustom'
import { colors } from '../../../constants/colors'
import { LIMIT_ALL } from '../../../constants/pagination'
import { RouteImage } from '../../../assets/routeImage'
import Dropdown from '../../../component/dropdown/Dropdown';
import LabelCustom from '../../../component/label/LabelCustom';
import AutocompleteSelect from '../../../component/select/autoCompleteSelect';

// TABS
import { ProjectApi, createProject, createTabs, detailBudget, detailDepartment, detailIndicator, detailResponsible, detailWorkPeriod } from '../../../api/project/project.api';
import { projectTabsProps, indicatorTabsProps, CustomTabPanel, IndicatorCustomTabPanel, CustomTab } from './tabs/createProjectsTabs';
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api';

import { TypesApi } from '../../../api/type/type.api';
import { StrategyApi, getStrategy } from '../../../api/strategy/strategy.api';
import { TacticsApi, getTactics } from '../../../api/tactics/tactics.api';
import { PlanApi } from '../../../api/plan/plan.api';
import { ClustersApi } from '../../../api/clusters/clusters.api';
import { BudgetApi } from '../../../api/budget/budget.api';
import { EmployeesApi } from '../../../api/employee/Employees.api';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import Loading from '../../../component/loading/Loading';
import { debouncedApiCall, filterActiveOptions, formatCurrency, formatCurrencyData, handleTypingNumber, revertFormatCurrency } from '../../../utils/app.utils';
import { numberFormat } from '../../../utils/common';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { DepartMentApi } from '../../../api/department/department.api';

// ERROR MESSAGE
import {
    errorNotificationType,
    initStateErrorMessage,
    errorMessageText
} from './type/error-type/error.notification';
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice';
import { IndicatorsApi } from '../../../api/indicators/indicators.api';
import { DetailAccordion, MainAccordion, TopicAccordion } from '../../../component/accordion/accordion.custom';
import { notificationSwal } from '../../../utils/notification.swal';
import Swal from 'sweetalert2';

const CreateProjectInformation = () => {
    // CONSTANT 👇
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const navigate: NavigateFunction = useNavigate()

    // STATE 👇
    // const [isDisbursement, setIsDisbursement] = useState<boolean>(false);
    const [projectTabs, setProjectTabs] = useState<number>(0);
    const [indicatorTabs, setIndicatorTabs] = useState<number>(0);
    const [isActivity, setIsActivity] = useState<boolean>(true);
    const [hideDetailWorkPeriod, setHideDetailWorkPeriod] = useState<boolean>(false);
    const [switchCount, setSwitchCount] = useState<boolean>(false);
    const [stickyActive, setStickyActive] = useState<boolean>(false)
    const [keywordIndicator, setKeywordIndicator] = useState<string>("");
    const [keywordLoading, setKeywordLoading] = useState<boolean>(false);

    const handleChangeProjectTabs = (event: React.SyntheticEvent, newValue: number) => setProjectTabs(newValue)
    const handleChangeIndicatorTabs = (event: React.SyntheticEvent, newValue: number) => setIndicatorTabs(newValue)

    const handleAddProject = () => {
        let projectData: createTabs = {
            projectActivitiesName: "",
            detailBudget: [{
                equipmentBudget: "",
                extraBudget: "",
                idBudget: 0,
                projectBudget: "",
                reducedBudget: "",
                remark: "",
                sumBudget: ""
            }],
            detailDisbursement: [{
                endDate: "",
                budget: "",
                paid: "",
                unpaid: "",
            }],
            detailResponsible: [{
                idEmployee: 0,
                percent: 0
            }],
            detailWorkPeriod: [{
                endDate: "",
                startDate: ""
            }],
            detailIndicators: [{
                idIndicators: undefined,
                indicatorsName: "",
                max1: 0,
                max2: 0,
                max3: 0,
                max4: 0,
                max5: 0,
                min1: 0,
                min2: 0,
                min3: 0,
                min4: 0,
                min5: 0,
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                percent: 0
            }]
        }
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: [...prev.tabs, projectData]
            }
        })
        setProjectTabs(formProject.tabs?.length)
    };


    // TESTING API
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<any[]>([]);
    const [tactics, setTactics] = useState<any[]>([]);
    const [plans, setPlans] = useState<any[]>([]);
    const [clusters, setClusters] = useState<any[]>([]);
    const [budgetSource, setBudgetSource] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [statusId, setStatusId] = useState<number>(50);
    const [department, setDepartment] = useState<any[]>([]);
    const [indicators, setIndicators] = useState<any[]>([])
    const [idDepartment, setIdDepartment] = useState<number | null>(null);
    const [subAllBudget, setSumAllBudget] = useState<any>(null);


    const [errorMessage, setErrorMessage] = useState<errorNotificationType>(initStateErrorMessage)

    const [formProject, setFormProject] = useState<createProject>({
        idDepartment: null,
        idFiscalYear: null,
        idStrategy: null,
        idPlan: null,
        idClusters: 0,
        projectName: "",
        idType: null,
        idStatus: 0,
        idMainResponsible: 0,
        idTactics: 0,
        isPublic: false,
        percentMainResponsible: 0,
        projectStatus: t("STATUS.ACTIVE"),
        projectDesc: "",
        projectEndDate: "",
        projectStartDate: "",
        detailWorkPeriod: [
            {
                startDate: "",
                endDate: "",
            }
        ],
        detailDisbursement: [
            {
                endDate: "",
                budget: "",
                paid: "",
                unpaid: "",
            }
        ],
        detailBudget: [
            {
                idBudget: 0,
                projectBudget: 0,
                equipmentBudget: 0,
                extraBudget: 0,
                reducedBudget: 0,
                remark: "",
                sumBudget: ""
            }
        ],
        detailResponsible: [],
        detailIndicators: [
            {
                idIndicators: 1,
                indicatorsName: "",
                max1: 0,
                max2: 0,
                max3: 0,
                max4: 0,
                max5: 0,
                min1: 0,
                min2: 0,
                min3: 0,
                min4: 0,
                min5: 0,
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                percent: 0
            }
        ],
        tabs: [{
            detailBudget: [
                {
                    equipmentBudget: "",
                    extraBudget: "",
                    idBudget: null,
                    projectBudget: "",
                    reducedBudget: "",
                    remark: "",
                    sumBudget: ""
                }
            ],
            detailDisbursement: [
                {
                    endDate: "",
                    budget: "",
                    paid: "",
                    unpaid: "",
                }
            ],
            detailResponsible: [
                {
                    idEmployee: 0,
                    percent: null
                }
            ],
            detailWorkPeriod: [
                {
                    endDate: "",
                    startDate: ""
                }
            ],
            detailIndicators: [{
                idIndicators: undefined,
                indicatorsName: "",
                max1: 0,
                max2: 0,
                max3: 0,
                max4: 0,
                max5: 0,
                min1: 0,
                min2: 0,
                min3: 0,
                min4: 0,
                min5: 0,
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                percent: 0
            }]
        }]
    })

    // ช่องด้านบน 
    const handleClearDate = (name: string) => {
        setFormProject((prev) => ({
            ...prev,
            [name]: "",
            tabs: prev.tabs.map((list) => {
                return {
                    ...list,
                    detailWorkPeriod: list.detailWorkPeriod.map((data) => {
                        return {
                            ...data,
                            endDate: "",
                            startDate: ""
                        }
                    })
                }
            })
        }))
    }
    const handleChangeDate = (name: string, value: any) => {
        setFormProject((prev) => {
            return {
                ...prev,
                [name]: value,
                tabs: prev.tabs.map((list) => {
                    return {
                        ...list,
                        detailWorkPeriod: list.detailWorkPeriod.map((data) => {
                            return {
                                ...data,
                                startDate: data.startDate,
                                endDate: moment(data.endDate).isAfter(value) ? "" : data.endDate
                            }
                        })
                    }
                })
            }
        })
    }
    const handleDeleteTabs = (index: number) => {
        Swal.fire({
            title: "คุณต้องการลบกิจกรรมย่อย?",
            animation: true,
            showCancelButton: true,
            allowEnterKey: true,
            confirmButtonColor: colors.themeMainColor,
            cancelButtonColor: colors.danger,
            cancelButtonText: t("BUTTON.CANCEL"),
            showClass: {
                popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
            },
            hideClass: {
                popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
            },
            confirmButtonText: "ลบ",
        }).then((result) => {
            if (result.isConfirmed) {
                setFormProject((prev) => {
                    return {
                        ...prev,
                        tabs: prev.tabs.filter((_, i: number) => i !== index)
                    }
                })
            }
        });
    }

    // งวดความคืบหน้าโครงการ
    const handleAddDetailWorkPeriod = (mainIndex: number) => {
        let addDetailWork: detailWorkPeriod = {
            endDate: "",
            startDate: ""
        }

        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, index: number) => {
                    if (mainIndex === index) {
                        return {
                            ...list,
                            detailWorkPeriod: [...list.detailWorkPeriod, addDetailWork]
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleChangeDetailWorkPeriod = (name: string, index: number, indexMain: number) => (event: any) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, iMain: number) => {
                    if (iMain === indexMain) {
                        return {
                            ...list,
                            detailWorkPeriod: list.detailWorkPeriod.map((obj, i: number) => {
                                if (index === i) {
                                    return {
                                        ...obj,
                                        [name]: moment(event).format("YYYY-MM-DD")
                                    }
                                } else {
                                    return {
                                        ...obj
                                    }
                                }
                            })
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleClearDetailWorkPeriod = (name: string, index: number, indexMain: number) => () => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, iMain: number) => {
                    if (iMain === indexMain) {
                        return {
                            ...list,
                            detailWorkPeriod: list.detailWorkPeriod.map((obj, i: number) => {
                                if (index === i) {
                                    return {
                                        ...obj,
                                        [name]: ""
                                    }
                                } else {
                                    return {
                                        ...obj
                                    }
                                }
                            })
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleDeleteDetailWorkPeriod = (mainIndex: number, index: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, tabIndex: number) => {
                    if (mainIndex === tabIndex) {
                        return {
                            ...list,
                            detailWorkPeriod: list.detailWorkPeriod.filter((sub, i: number) => i !== index)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleChangeDetailWorkPeriodWithStartDateAndEndDate = (name: 'startDate' | 'endDate', value: any, detailIndex: number) => {
        setFormProject((prev) => {
            return {
                ...prev, tabs: prev?.tabs?.map((list) => {
                    return {
                        ...list, detailWorkPeriod: list?.detailWorkPeriod?.map((data, index: number) => {
                            return index === detailIndex ? { ...data, [name]: value } : data
                        })
                    }
                })
            }
        })
    }

    // งวดเบิกจ่าย
    const handleAddDetailDisbursement = (mainIndex: number) => {
        let newRow: detailDepartment = {
            budget: "",
            endDate: "",
            paid: "",
            unpaid: "",
        }
        setFormProject((prev) => ({
            ...prev,
            tabs: prev.tabs.map((list, index) => {
                if (mainIndex === index) {
                    return {
                        ...list,
                        detailDisbursement: [...list.detailDisbursement, newRow]
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleClearDetailDisbursement = (name: string, indexDetail: number, indexMain: number) => (event: any) => {
        setFormProject((prev) => ({
            ...prev,
            tabs: prev.tabs.map((list, index: number) => {
                if (index === indexMain) {
                    return {
                        ...list,
                        detailDisbursement: list.detailDisbursement.map((sub, subIndex: number) => {
                            if (indexDetail === subIndex) {
                                return {
                                    ...sub,
                                    [name]: ""
                                }
                            } else {
                                return {
                                    ...sub
                                }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeDetailDisbursement = (name: string, indexDetail: number, indexMain: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        const formattedValue = formatCurrency(inputValue);
        setFormProject((prev) => ({
            ...prev,
            tabs: prev.tabs.map((list, index: number) => {
                if (index === indexMain) {
                    return {
                        ...list,
                        detailDisbursement: list.detailDisbursement.map((sub, subIndex: number) => {
                            return subIndex === indexDetail
                                ? { ...sub, [name]: formattedValue }
                                : { ...sub };
                        })
                    };
                } else {
                    return { ...list };
                }
            })
        }));

    };
    const handleDeleteDetailDisbursement = (index: number, mainIndex: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, i: number) => {
                    if (i === mainIndex) {
                        return {
                            ...list,
                            detailDisbursement: list.detailDisbursement.filter((data, subIndex: number) => subIndex !== index)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }

    // งบประมาณ
    const handleAddBudget = (mainIndex: number) => {
        let newBudget: detailBudget = {
            equipmentBudget: "",
            extraBudget: "",
            idBudget: 0,
            projectBudget: "",
            reducedBudget: "",
            remark: "",
            sumBudget: ""
        }
        setFormProject((prev) => ({
            ...prev, tabs: prev.tabs.map((list, index: number) => {
                if (mainIndex === index) {
                    return {
                        ...list,
                        detailBudget: [...list.detailBudget, newBudget]
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeBudget = (name: string, indexDetail: number, indexMain: number, clear?: boolean) => (event: any) => {
        const inputValue = event.target?.value;
        const formatValue = formatCurrency(inputValue)
        setFormProject((prev) => ({
            ...prev, tabs: prev.tabs.map((list, index: number) => {
                if (indexMain === index) {
                    return {
                        ...list,
                        detailBudget: list.detailBudget.map((detail, subIndex) => {
                            if (subIndex === indexDetail) {
                                return {
                                    ...detail,
                                    [name]: clear ? "" : formatValue
                                }
                            } else {
                                return {
                                    ...detail
                                }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeIdBudget = (indexDetail: number, indexMain: number) => (idBudget: number | null) => {
        clearErrorMessage()
        setFormProject((prev) => ({
            ...prev, tabs: prev.tabs.map((list, index: number) => {
                if (indexMain === index) {
                    return {
                        ...list,
                        detailBudget: list.detailBudget.map((detail, subIndex) => {
                            if (subIndex === indexDetail) {
                                return {
                                    ...detail,
                                    idBudget: idBudget || 0
                                }
                            } else {
                                return {
                                    ...detail
                                }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleDeleteBudget = (index: number, mainIndex: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, i: number) => {
                    if (i === mainIndex) {
                        return {
                            ...list,
                            detailBudget: list.detailBudget.filter((data, subIndex: number) => subIndex !== index)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleAddIndicator = (mainIndex: number) => {
        let newIndicator: detailIndicator = {
            idIndicators: undefined,
            indicatorsName: "",
            max1: 0,
            max2: 0,
            max3: 0,
            max4: 0,
            max5: 0,
            min1: 0,
            min2: 0,
            min3: 0,
            min4: 0,
            min5: 0,
            description1: "",
            description2: "",
            description3: "",
            description4: "",
            description5: "",
            percent: 0
        }

        setFormProject(prev => {
            const updatedTabs = prev.tabs.map((tab, tabIndex: number) => {
                if (tabIndex === mainIndex) {
                    return {
                        ...tab,
                        detailIndicators: [...tab.detailIndicators, newIndicator]
                    };
                } else {
                    return { ...tab };
                }
            });

            return {
                ...prev,
                tabs: updatedTabs
            };
        });
    };
    const handleDeleteTabsIndicator = (detailIndex: number, mainIndex: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, index) => {
                    if (mainIndex === index) {
                        return {
                            ...list,
                            detailIndicators: list.detailIndicators.filter((data, i) => i !== detailIndex)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }

    // ตัวชี้วัดประเมินโครงการ
    const handleChangeIndicatorActivities = (name: string, detailIndices: number, mainIndex: number, isString?: boolean) => (event: any) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, i: number) => {
                    if (mainIndex === i) {
                        return {
                            ...list,
                            detailIndicators: list.detailIndicators.map((data, deIndex: number) => {
                                if (deIndex === detailIndices) {
                                    return {
                                        ...data,
                                        [name]: isString ? event.target?.value : Number(event.target?.value) > 1000 ? 0 : Number(event.target?.value)
                                    };
                                } else {
                                    return {
                                        ...data
                                    };
                                }
                            })
                        };
                    } else {
                        return {
                            ...list
                        };
                    }
                })
            };
        });
    };
    const handleAutocompleteChangeIndicator = (name: string, value: any, indexDetail: number, indexMain: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, mainIndex: number) => {
                    return indexMain === mainIndex ? {
                        ...list, detailIndicators: list.detailIndicators.map((indicator, detailIndex: number) => {
                            return indexDetail === detailIndex ? {
                                ...indicator,
                                [name]: value,

                            } : { ...indicator }
                        })
                    } : { ...list }
                })
            }
        })
    }



    // ผู้รับผิดชอบโครงการ
    const handleAddDetailResponsible = (mainIndex: number) => {
        let newData: detailResponsible = {
            idEmployee: 0,
            percent: 0
        }

        setFormProject((prev) => ({
            ...prev, tabs: prev.tabs.map((list, index: number) => {
                if (index === mainIndex) {
                    return {
                        ...list,
                        detailResponsible: [...list.detailResponsible, newData]
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleChangeDetailResponsible = (name: string, indexDetail: number, indexMain: number, value?: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, index: number) => {
                    if (index === indexMain) {
                        return {
                            ...list,
                            detailResponsible: list.detailResponsible.map((detail, i: number) => {
                                if (i === indexDetail) {
                                    return {
                                        ...detail,
                                        [name]: value ? value : Number(event.target.value) > 100 ? 0 : Number(event.target?.value)
                                    }
                                } else {
                                    return {
                                        ...detail
                                    }
                                }
                            })
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleDeleteDetailResponsible = (indexDetail: number, indexMain: number) => {
        setFormProject((prev) => {
            return {
                ...prev,
                tabs: prev.tabs.map((list, mainIndex: number) => {
                    if (mainIndex === indexMain) {
                        return {
                            ...list,
                            detailResponsible: list.detailResponsible.filter((_, i: number) => i !== indexDetail)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }

    // API
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setFiscalYear(res.data?.result?.items)
                    setFormProject((prev) => {
                        return {
                            ...prev,
                            idStrategy: 0,
                            idTactics: 0,
                        }
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetType = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result)
                    setTypes(res.data?.result?.items);
                    if (res.data?.result?.items?.length > 0) {
                        const defaultType = filterActiveOptions(res.data?.result?.items, 'typeStatus', 'idType')[0] || res.data?.result?.items[0]
                        setFormProject((prev) => {
                            return {
                                ...prev,
                                idType: defaultType?.idType
                            }
                        })
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idFiscalYear])
    const handleGetStrategy = useCallback(async () => {
        let condition: getStrategy = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idFiscalYear])
    const handleGetTactics = useCallback(async () => {
        let condition: getTactics = { limit: LIMIT_ALL }
        if (formProject.idStrategy) condition = { ...condition, idStrategy: formProject.idStrategy }
        await TacticsApi.getTactics(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setTactics(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idStrategy, formProject.idFiscalYear])
    const handleGetPlan = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setPlans(res.data?.result?.items)

                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetClusters = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (formProject.idFiscalYear) condition = { ...condition, idFiscalYear: formProject.idFiscalYear }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setClusters(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [formProject.idFiscalYear])
    const handleGetBudgetSource = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await BudgetApi.getBudgets(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setBudgetSource(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetEmployees = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
        setKeywordLoading(true)
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    setKeywordLoading(false)
                    // console.log(res.data?.result?.items)
                    setEmployees(res.data?.result?.items)
                }
            })
            .catch(error => {
                setKeywordLoading(false)
                console.log(error)
            })
    }, [idDepartment])
    const handleGetIndicators = useCallback(async () => {
        let condition: any = {}
        if (keywordIndicator) condition = { ...condition, keyword: keywordIndicator }
        setKeywordLoading(true)
        await IndicatorsApi.GetIndicators(condition)
            .then(res => {
                if (res.status === 200) {
                    setKeywordLoading(false)
                    setIndicators(res.data?.result?.items)
                }
            })
            .catch(error => {
                // throw new error
                console.log(error)
            })
    }, [keywordIndicator])

    const validateForm = () => {
        let hasErrors = false;
        if (!idDepartment) {
            setErrorMessage((prev) => ({ ...prev, ID_DEPARTMENT: errorMessageText.ID_DEPARTMENT }));
            hasErrors = true;
        }
        if (!formProject.idFiscalYear) {
            setErrorMessage((prev) => ({ ...prev, ID_FISCAL_YEAR: errorMessageText.ID_FISCAL_YEAR }));
            hasErrors = true;
        }
        if (!formProject.idStrategy) {
            setErrorMessage((prev) => ({ ...prev, ID_STRATEGY: errorMessageText.ID_STRATEGY }));
            hasErrors = true;
        }
        if (!formProject.idTactics) {
            setErrorMessage((prev) => ({ ...prev, ID_TACTICS: errorMessageText.ID_TACTICS }));
            hasErrors = true;
        }
        if (!formProject.idPlan) {
            setErrorMessage((prev) => ({ ...prev, ID_PLAN: errorMessageText.ID_PLAN }));
            hasErrors = true;
        }
        if (!formProject.projectStartDate) {
            setErrorMessage((prev) => ({ ...prev, START_DATE_PROJECT: errorMessageText.START_DATE_PROJECT }));
            hasErrors = true;
        }
        if (!formProject.projectName) {
            setErrorMessage((prev) => ({ ...prev, PROJECT_NAME: errorMessageText.PROJECT_NAME }));
            hasErrors = true;
        }
        if (!formProject.idType) {
            setErrorMessage((prev) => ({ ...prev, ID_TYPE: errorMessageText.ID_TYPE }));
            hasErrors = true;
        }
        // if (!formProject.idClusters) {
        //     setErrorMessage((prev) => ({ ...prev, ID_CLUSTERS: errorMessageText.ID_CLUSTERS }));
        //     hasErrors = true;
        // }
        formProject.detailDisbursement.map((list) => {
            if (!list.budget) {
                setErrorMessage((prev) => ({ ...prev, BUDGET: errorMessageText.BUDGET }))
                return !hasErrors
            }
        })
        formProject.tabs.map((data) => {
            return {
                ...data,
                detailBudget: data.detailBudget.map((list) => {
                    if (!list.idBudget) {
                        setErrorMessage((prev) => ({ ...prev, ID_BUDGET: errorMessageText.ID_BUDGET }))
                        return !hasErrors
                    } else {
                        return hasErrors
                    }
                })

            }
        })
        formProject.tabs.forEach((data) => {
            if (data.detailResponsible?.filter((list) => list.idEmployee === 0).length > 0) {
                swalError('กรุณาระบุผู้รับผิดชอบโครงการให้ครบถ้วน')
                return hasErrors = true
            }
        })
        return !hasErrors;
    };

    const handleSubmitForm = async (event: React.FormEvent) => {
        event.preventDefault();
        const validated = validateForm()

        const sumAllBudget = numberFormat(formProject.tabs.reduce((total, tab) => total + tab.detailBudget.reduce((a, b) => a + (revertFormatCurrency(b.equipmentBudget.toString()) + revertFormatCurrency(b.extraBudget.toString()) + revertFormatCurrency(b.projectBudget.toString()) - revertFormatCurrency(b.reducedBudget.toString())), 0), 0)) || 0
        const sumAllPaid = formProject.tabs[0]?.detailDisbursement.reduce((x: any, y: any) => x + formatCurrencyData(y.paid, 'convert'), 0) || 0
        const subAllUnpaid = numberFormat(formProject?.tabs.reduce((total, tab) => total + tab.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.unpaid.toString()), 0), 0)) || 0

        let condition: any = {
            sumAllBudget: formatCurrencyData(sumAllBudget.toString(), 'convert'),
            sumAllPaid: sumAllPaid,
            sumAllUnpaid: formatCurrencyData(subAllUnpaid.toString(), 'convert'),
            idDepartment: formProject.idDepartment || idDepartment,
            projectName: formProject.projectName,
            projectDesc: formProject.tabs[0]?.projectDesc,
            idFiscalYear: formProject.idFiscalYear,
            idStrategy: formProject.idStrategy,
            idTactics: formProject.idTactics,
            idPlan: formProject.idPlan,
            idType: formProject.idType,
            idStatus: statusId, //isActivity ? 100 : 110
            isPublic: formProject.isPublic,
            idClusters: formProject.idClusters,
            idMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.idEmployee,
            percentMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.percent,
            projectStartDate: formProject.projectStartDate,
            projectEndDate: formProject.projectEndDate,
            projectStatus: formProject.projectStatus,
            detailWorkPeriod: formProject.tabs[0]?.detailWorkPeriod,
            detailDisbursement: formProject.tabs[0]?.detailDisbursement.map((list) => ({ ...list, budget: revertFormatCurrency(list.budget.toString()), paid: revertFormatCurrency(list.paid.toString()), unpaid: revertFormatCurrency(list.unpaid.toString()) })),
            detailBudget: formProject.tabs[0]?.detailBudget.map((list) => {
                const sumBudget = Number(formatCurrencyData(list.equipmentBudget.toString(), 'convert')) + Number(formatCurrencyData(list.extraBudget.toString(), 'convert')) + Number(formatCurrencyData(list.projectBudget.toString(), 'convert')) - Number(formatCurrencyData(list.reducedBudget.toString(), 'convert')) || 0
                return {
                    ...list,
                    equipmentBudget: revertFormatCurrency(list.equipmentBudget.toString()),
                    extraBudget: revertFormatCurrency(list.extraBudget.toString()),
                    projectBudget: revertFormatCurrency(list.projectBudget.toString()),
                    reducedBudget: revertFormatCurrency(list.reducedBudget.toString()),
                    sumBudget: list.sumBudget ? revertFormatCurrency(list.sumBudget.toString()) : sumBudget
                }
            }),
            detailResponsible: formProject.tabs[0]?.detailResponsible,
            detailIndicators: formProject.tabs[0]?.detailIndicators,
            detailActivities: !isActivity ? [] : formProject.tabs.slice(1, formProject.tabs.length).map((list) => {
                const sumAllPaidActivity: any = list.detailDisbursement.reduce((x: any, y: any) => x + formatCurrencyData(y.paid.toString(), 'convert'), 0) || 0
                const sumAllUnpaidActivity: any = list.detailDisbursement.reduce((x: any, y: any) => x + formatCurrencyData(y.unpaid.toString(), 'convert'), 0) || 0
                return {
                    sumAllBudget: formatCurrencyData(sumAllBudget.toString(), 'convert'),
                    subAllPaid: sumAllPaidActivity,
                    subAllUnpaid: sumAllUnpaidActivity,
                    projectActivitiesName: list.projectActivitiesName,
                    projectActivitiesDesc: list.projectDesc,
                    idMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.idEmployee,
                    percentMainResponsible: formProject.tabs[0]?.detailResponsible[0]?.percent,
                    detailWorkPeriod: [...list.detailWorkPeriod],
                    detailDisbursement: list.detailDisbursement.map((list) => ({ ...list, budget: revertFormatCurrency(list.budget.toString()), paid: revertFormatCurrency(list.paid.toString()), unpaid: revertFormatCurrency(list.unpaid.toString()) })),
                    detailResponsible: [...list.detailResponsible],
                    detailIndicators: [...list.detailIndicators]
                }
            })
        }
        if (!validated) {
            return false
        } else {
            // console.log(condition)
            dispatch(setLoading())
            await ProjectApi.createProject(condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        swalSuccess(notificationSwal.success || res.data?.description, 'go', '/auth/project-information')
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
                .finally(() => dispatch(unsetLoading()))
        }
    }
    const handleGetDepartment = async () => {
        await DepartMentApi.getDetailDepartment(1)
            .then(res => {
                if (res.status === 200) {
                    setDepartment(res.data?.result?.departmentList)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const clearErrorMessage = () => {
        setErrorMessage(initStateErrorMessage)
    }

    useEffect(() => {
        handleGetTactics();
    }, [formProject.idStrategy, formProject.idFiscalYear])

    useEffect(() => {
        handleGetClusters();
        handleGetType();
        handleGetStrategy();
    }, [formProject.idFiscalYear])

    useEffect(() => {
        handleGetFiscalYear()
        handleGetPlan();
        handleGetBudgetSource();
        handleGetDepartment();
    }, [])
    useEffect(() => {
        handleGetEmployees();
    }, [handleGetEmployees])
    useEffect(() => {
        handleGetIndicators();
    }, [keywordIndicator])
    useEffect(() => {
        if (formProject.tabs?.length === 1) setProjectTabs(0)
        setProjectTabs(formProject.tabs.length - 1)
    }, [formProject.tabs.length])

    useEffect(() => {
        setIndicatorTabs(0)
        setIsActivity(!!types?.find((list: any) => list?.idType === formProject.idType)?.isActivities)
    }, [formProject.idType, formProject.tabs?.length])

    useEffect(() => {
        setSumAllBudget(formProject?.tabs[0]?.detailBudget.reduce((a, b) => a + revertFormatCurrency(b.sumBudget.toString()), 0))
    }, [formProject.tabs[0]?.detailBudget])

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 200) {
                setStickyActive(true);
            } else {
                setStickyActive(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <form onSubmit={handleSubmitForm}>
                        <motion.section
                            className='flex flex-col gap-y-[20px]'
                            initial={{ x: 100 }}
                            animate={{ x: 0 }}
                            transition={{ duration: .4, delay: .1 }}>
                            {/* BUTTON */}
                            <article className='relative w-full gap-3 flex items-start md:items-center flex-col  md:flex-row justify-between'>
                                <span>
                                    <Typography className='text-primary' variant='h4'>
                                        {t("สร้างโครงการ")}
                                    </Typography>
                                </span>
                                <Box
                                    sx={{
                                        position: stickyActive ? 'fixed' : 'relative',
                                        top: stickyActive ? 20 : 0,
                                        right: stickyActive ? 20 : 0,
                                        zIndex: 999
                                    }}
                                    className='flex flex-wrap md:flex-nowrap gap-1 gap-y-2'>
                                    <ButtonOutlined
                                        onClick={() => setStatusId(50)}
                                        type='submit'
                                        variant='outlined'>
                                        <Typography className='text-primary' variant='body1'>
                                            {t("BUTTON.SAVE_DRAFT")}
                                        </Typography>
                                    </ButtonOutlined>
                                    <ButtonContained
                                        onClick={(e) => setStatusId(80)}
                                        type='submit'
                                        variant='contained'>
                                        <Typography variant='body1'>
                                            {t("BUTTON.SAVE")}
                                        </Typography>
                                    </ButtonContained>
                                </Box>
                            </article>
                            {/* FILTER */}
                            <article className='grid grid-cols-12 gap-2 mt-8'>
                                <div className='col-span-12'>
                                    <AutocompleteSelect
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("หน่วยงาน")}
                                        labelId="label-status"
                                        options={filterActiveOptions(department, 'departmentStatus', 'idDepartment', [idDepartment])}
                                        getOptionLabel={(option: any) => option?.departmentName || ''}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idDepartment === value?.idDepartment}
                                        value={department?.find((list: any) => list?.idDepartment === idDepartment) || null}
                                        onChange={(_, value: any) => {
                                            setIdDepartment(value?.idDepartment || null)
                                            clearErrorMessage()
                                        }}
                                        helperText={errorMessage.ID_DEPARTMENT}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 md:col-span-3'>
                                    {fiscalYear && (
                                        <AutocompleteSelect
                                            onInvalid={() => validateForm()}
                                            required
                                            heading={t("ปีงบประมาณ")}
                                            labelId="label-fiscal-year"
                                            options={filterActiveOptions(fiscalYear, 'fiscalYearStatus', 'idFiscalYear', [formProject.idFiscalYear])}
                                            getOptionLabel={(option: any) => String(option?.fiscalYear ?? '')}
                                            getOptionDisabled={(option: any) => option?.fiscalYearStatus === t("STATUS.INACTIVE")}
                                            isOptionEqualToValue={(option: any, value: any) => option?.idFiscalYear === value?.idFiscalYear}
                                            value={fiscalYear.find((list: any) => list?.idFiscalYear === formProject.idFiscalYear) || null}
                                            helperText={errorMessage.ID_FISCAL_YEAR}
                                            onChange={(_, value: any) => {
                                                setFormProject((prev) => ({
                                                    ...prev,
                                                    idFiscalYear: value?.idFiscalYear || null,
                                                    idTactics: null,
                                                    idStrategy: null
                                                }))
                                                clearErrorMessage()
                                            }}
                                        />
                                    )}
                                </div>
                                <div className='col-span-12 md:col-span-9'>
                                    <AutocompleteSelect
                                        onInvalid={() => validateForm()}
                                        disabled={!formProject.idFiscalYear}
                                        required
                                        heading={t("ยุทธศาสตร์")}
                                        labelId="label-setStrategy"
                                        options={filterActiveOptions(strategy, 'strategyStatus', 'idStrategy', [formProject.idStrategy])}
                                        getOptionLabel={(option: any) => option?.strategyName || ''}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idStrategy === value?.idStrategy}
                                        value={strategy?.find((list: any) => list?.idStrategy === formProject.idStrategy) || null}
                                        helperText={errorMessage.ID_STRATEGY}
                                        onChange={(_, value: any) => {
                                            setFormProject((prev) => ({ ...prev, idStrategy: value?.idStrategy || null, idTactics: null }))
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-5'>
                                    <AutocompleteSelect
                                        onInvalid={() => validateForm()}
                                        disabled={!formProject.idStrategy || !formProject.idFiscalYear}
                                        required
                                        heading={t("กลยุทธ์")}
                                        labelId="label-tacticsId"
                                        options={filterActiveOptions(tactics, 'tacticsStatus', 'idTactics', [formProject.idTactics])}
                                        getOptionLabel={(option: any) => option?.tacticsName || ''}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idTactics === value?.idTactics}
                                        value={tactics?.find((list: any) => list?.idTactics === formProject.idTactics) || null}
                                        helperText={errorMessage.ID_TACTICS}
                                        onChange={(_, value: any) => {
                                            setFormProject((prev) => ({ ...prev, idTactics: value?.idTactics || null }))
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-3'>
                                    <AutocompleteSelect
                                        onInvalid={() => validateForm()}
                                        required
                                        heading={t("แผนงาน")}
                                        labelId="label-plan"
                                        options={filterActiveOptions(plans, 'planStatus', 'idPlan', [formProject.idPlan])}
                                        getOptionLabel={(option: any) => option?.planName || ''}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idPlan === value?.idPlan}
                                        value={plans?.find((list: any) => list?.idPlan === formProject.idPlan) || null}
                                        helperText={errorMessage.ID_PLAN}
                                        onChange={(_, value: any) => {
                                            setFormProject((prev) => ({ ...prev, idPlan: value?.idPlan || null }))
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        helperText={errorMessage.START_DATE_PROJECT}
                                        disableEndDate={formProject.projectEndDate}
                                        inputName='startProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        required={true}
                                        key={"START_PROJECT"}
                                        value={formProject.projectStartDate}
                                        placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                        onClear={() => handleClearDate('projectStartDate')}
                                        onChange={(e: any) => {
                                            handleChangeDate('projectStartDate', moment(e).format("YYYY-MM-DD"))
                                            clearErrorMessage()
                                            if (formProject?.tabs[0]?.detailWorkPeriod.length === 1) {
                                                handleChangeDetailWorkPeriodWithStartDateAndEndDate('startDate', moment(e).format("YYYY-MM-DD"), 0)
                                            }

                                        }}
                                        allowClear
                                        heading={t("เริ่มต้นโครงการ")}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                    <InputDatePicker
                                        disableStartDate={formProject.projectStartDate}
                                        disabled={!formProject.projectStartDate}
                                        inputName='endProject'
                                        inputHeight={42}
                                        dateFormat="DD/MM/YYYY"
                                        required={true}
                                        key={"END_PROJECT"}
                                        value={formProject.projectEndDate}
                                        placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                        onClear={() => handleClearDate('projectEndDate')}
                                        onChange={(e: any) => {
                                            handleChangeDate('projectEndDate', moment(e).format("YYYY-MM-DD"))
                                            if (formProject?.tabs[0]?.detailWorkPeriod.length === 1) {
                                                handleChangeDetailWorkPeriodWithStartDateAndEndDate('endDate', moment(e).format("YYYY-MM-DD"), 0)
                                            }
                                        }}
                                        allowClear
                                        heading={t("สิ้นสุดโครงการ")}
                                    />
                                </div>
                            </article>
                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12'>
                                    <InputTextField
                                        onInvalid={() => validateForm()}
                                        helperText={errorMessage.PROJECT_NAME}
                                        required
                                        value={formProject.projectName}
                                        heading={t("ชื่อโครงการ")}
                                        onchange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setFormProject((prev) => ({ ...prev, projectName: event.target.value }))
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                            </article>

                            <article className='grid grid-cols-12 gap-2'>
                                <div className='col-span-12 lg:col-span-3'>
                                    <AutocompleteSelect
                                        required
                                        helperText={errorMessage.ID_TYPE}
                                        onInvalid={() => validateForm()}
                                        heading={t("ประเภทโครงการ")}
                                        labelId="label-project-type"
                                        options={filterActiveOptions(types, 'typeStatus', 'idType', [formProject.idType])}
                                        getOptionLabel={(option: any) => option?.typeName || ''}
                                        getOptionDisabled={(option: any) => option?.typeStatus === t("STATUS.INACTIVE")}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idType === value?.idType}
                                        value={types?.find((list: any) => list?.idType === formProject.idType) || null}
                                        onChange={(_, value: any) => {
                                            setFormProject((prev) => ({ ...prev, idType: value?.idType || null }))
                                            setProjectTabs(0)
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                                <div className='col-span-12 lg:col-span-4'>
                                    <AutocompleteSelect
                                        disabled={!formProject.idFiscalYear}
                                        onInvalid={() => validateForm()}
                                        // required
                                        heading={t("ประเภทกลุ่มภารกิจ (CLUSTERS)")}
                                        labelId="label-project-name"
                                        options={filterActiveOptions(clusters, 'clustersStatus', 'idClusters', [formProject.idClusters])}
                                        getOptionLabel={(option: any) => option?.clustersName || ''}
                                        isOptionEqualToValue={(option: any, value: any) => option?.idClusters === value?.idClusters}
                                        value={clusters?.find((list: any) => list?.idClusters === formProject.idClusters) || null}
                                        helperText={errorMessage.ID_CLUSTERS}
                                        onChange={(_, value: any) => {
                                            setFormProject((prev) => ({ ...prev, idClusters: value?.idClusters || 0 }))
                                            clearErrorMessage()
                                        }}
                                    />
                                </div>
                            </article>

                            {/* 👇 แสดงข้อมูลเป็น tabs แค่ประเภททั่วไป -> ประเภททั่วไป*/}
                            <article className='w-full'>
                                <Box sx={{ width: '100%', overflow: 'auto' }}>
                                    <Box
                                        sx={{
                                            display: isActivity ? 'flex' : 'none',
                                            // flexGrow: 1,
                                            justifyContent: 'space-between',
                                            gap: 10
                                        }}
                                        className='w-full flex flex-col justify-start overflow-auto items-start gap-2 md:flex-row md:justify-between md:items-end'>
                                        <Tabs
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            TabIndicatorProps={{
                                                sx: {
                                                    backgroundColor: colors.white,
                                                    display: "flex",
                                                    flexWrap: "wrap"
                                                }
                                            }}
                                            value={projectTabs}
                                            onChange={handleChangeProjectTabs}
                                            aria-label="project-tabs">
                                            {formProject.tabs?.map((list, index: number) => (
                                                <CustomTab
                                                    key={index}
                                                    className='relative'
                                                    label={
                                                        <div>
                                                            {index !== 0 && (
                                                                <button
                                                                    type='button'
                                                                    onClick={() => {
                                                                        handleDeleteTabs(index)
                                                                        setIndicatorTabs(0)
                                                                    }}
                                                                    className='absolute top-0 right-0 z-[99] hover:text-danger'>
                                                                    <HighlightOffOutlinedIcon className='text-sm scale-75' />
                                                                </button>
                                                            )}
                                                            <Typography>
                                                                {index === 0 ? "โครงการหลัก" : `กิจกรรม${index}`}
                                                            </Typography>
                                                        </div>
                                                    }
                                                    {...projectTabsProps(index)}
                                                />
                                            ))}
                                        </Tabs>
                                        <div className='max-w-xs overflow-hidden mr-10'>
                                            <ButtonOutlined
                                                onClick={handleAddProject}
                                                startIcon={<img src={RouteImage.addForm} alt='add-icon' />}
                                                sx={{
                                                    borderRadius: "6px 6px 0 0", width: 170, height: "42px", border: `1px solid ${colors.borderInput}`
                                                }}>
                                                <Typography className='text-primary'>{"เพิ่มโครงการย่อย"}</Typography>
                                            </ButtonOutlined>
                                        </div>
                                    </Box>
                                    <div className={`mt-2 ${isActivity && 'bg-bg_secondary'}`}>
                                        {formProject.tabs.map((list, index: number) => (
                                            <CustomTabPanel
                                                key={index}
                                                value={projectTabs}
                                                index={index}>
                                                <section className={`w-full`}>
                                                    <MainAccordion
                                                        defaultExpanded
                                                    >
                                                        <TopicAccordion
                                                            expandIcon={<Dropdown />}
                                                        >
                                                            <LabelCustom
                                                                variant='h6'
                                                                // isRequired={!isActivity ? false : true}
                                                                text='งวดความคืบหน้าโครงการ'
                                                            />
                                                        </TopicAccordion>
                                                        <DetailAccordion>
                                                            {index !== 0 && (
                                                                <InputTextField
                                                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                        setFormProject((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                tabs: prev.tabs.map((list, tabIndex: number) => {
                                                                                    if (index === tabIndex) {
                                                                                        return {
                                                                                            ...list,
                                                                                            projectActivitiesName: e.target.value
                                                                                        }
                                                                                    } else {
                                                                                        return {
                                                                                            ...list
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        })
                                                                    }}
                                                                    required
                                                                    value={list.projectActivitiesName}
                                                                    heading='ชื่อกิจกรรม'
                                                                />
                                                            )}
                                                            {/* งวดความคืบหน้าโครงการ */}
                                                            {list.detailWorkPeriod?.map((subList, i: number) => (
                                                                <motion.section key={i}
                                                                    className={`w-full ${hideDetailWorkPeriod && 'hidden'} `}>
                                                                    <article className='flex items-center justify-between'>
                                                                        <LabelCustom
                                                                            className='mt-2'
                                                                            text={t(`งวดที่ ${i + 1} ภายในวันที่`)}
                                                                            variant='body1'
                                                                        />
                                                                    </article>
                                                                    <article className="mt-2 grid grid-cols-12 gap-2">
                                                                        <div className='col-span-12 md:col-span-4 lg:col-span-2'>
                                                                            <InputDatePicker
                                                                                disabled={formProject.projectStartDate === "" || formProject.projectEndDate === ""}
                                                                                disableStartDate={
                                                                                    i === 0 ?
                                                                                        formProject.projectStartDate :
                                                                                        (i > 0 ? list.detailWorkPeriod[i - 1]?.endDate : undefined)
                                                                                }
                                                                                disableEndDate={formProject.projectEndDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                // required={!isActivity ? false : true}
                                                                                key={"START_PROJECT"}
                                                                                value={subList.startDate}
                                                                                placeholder={t('ระบุวันเริ่มต้นงวด')}
                                                                                onClear={handleClearDetailWorkPeriod('startDate', i, index)}
                                                                                onChange={handleChangeDetailWorkPeriod('startDate', i, index)}
                                                                                allowClear
                                                                                heading={t("เริ่มต้น")}
                                                                            />
                                                                        </div>
                                                                        <div className='col-span-12 md:col-span-4 lg:col-span-2'>
                                                                            <InputDatePicker
                                                                                disabled={formProject.projectStartDate === "" || formProject.projectEndDate === "" || subList.startDate === ""}
                                                                                disableEndDate={formProject.projectEndDate}
                                                                                disableStartDate={subList.startDate}
                                                                                inputName='startProject'
                                                                                inputHeight={42}
                                                                                dateFormat="DD/MM/YYYY"
                                                                                // required={!isActivity ? false : true}
                                                                                key={"END_PROJECT"}
                                                                                value={subList.endDate}
                                                                                placeholder={t('ระบุวันสิ้นสุดงวด')}
                                                                                onClear={handleClearDetailWorkPeriod('endDate', i, index)}
                                                                                onChange={handleChangeDetailWorkPeriod('endDate', i, index)}
                                                                                allowClear
                                                                                heading={t("สิ้นสุด")}
                                                                            />
                                                                        </div>
                                                                        <div className='col-span-12 lg:col-span-2 self-end'>
                                                                            {i === 0 ? (
                                                                                <ButtonOutlined
                                                                                    onClick={() => handleAddDetailWorkPeriod(index)}
                                                                                    sx={{ maxWidth: "75px", width: "100%", height: '42px' }}
                                                                                    startIcon={<img className='max-w-20' src={RouteImage.addButton} />}
                                                                                >
                                                                                    <Typography className='text-primary' variant='body1'>
                                                                                        {t("BUTTON.ADD")}
                                                                                    </Typography>
                                                                                </ButtonOutlined>
                                                                            ) : (
                                                                                <ButtonOutlinedDanger
                                                                                    onClick={() => handleDeleteDetailWorkPeriod(index, i)}
                                                                                    sx={{ maxWidth: "97px", width: "100%", height: '42px' }}
                                                                                    startIcon={<img className='max-w-20' src={RouteImage.delete} />}
                                                                                >
                                                                                    <Typography className='text-danger' variant='body1'>
                                                                                        {t("ลบ")}
                                                                                    </Typography>
                                                                                </ButtonOutlinedDanger>
                                                                            )}
                                                                        </div>
                                                                    </article>
                                                                </motion.section>
                                                            ))}
                                                        </DetailAccordion>
                                                    </MainAccordion>
                                                </section>


                                                {/* งวดเบิกจ่าย  👇 */}
                                                <section className='w-full mt-2'>
                                                    <article className='w-full'>
                                                        <div className='w-full'>
                                                            <MainAccordion
                                                                defaultExpanded
                                                            >
                                                                <TopicAccordion
                                                                    expandIcon={<Dropdown />}
                                                                >
                                                                    <LabelCustom
                                                                        variant='h6'
                                                                        text='งวดเบิกจ่าย'
                                                                    // isRequired={isActivity ? true : false}
                                                                    />
                                                                </TopicAccordion>
                                                                <DetailAccordion>
                                                                    <div className={`w-full grid grid-cols-12 gap-2 duration-100`}>
                                                                        {list.detailDisbursement?.map((subList, i: number) => (
                                                                            <motion.div
                                                                                className='contents'
                                                                                initial={{ y: -50 }}
                                                                                animate={{ y: 0 }}
                                                                                transition={{ ease: "easeInOut", stiffness: 40 }}
                                                                                key={index}>
                                                                                <div className='col-span-12 lg:col-span-2'>
                                                                                    <InputDatePicker
                                                                                        disabled={formProject.projectEndDate === "" || formProject.projectEndDate === ""}
                                                                                        disableStartDate={
                                                                                            i === 0 ?
                                                                                                formProject.projectStartDate :
                                                                                                (i > 0 ? list.detailDisbursement[i - 1]?.endDate : undefined)
                                                                                        }
                                                                                        disableEndDate={formProject.projectEndDate}
                                                                                        inputName='startProject'
                                                                                        inputHeight={42}
                                                                                        dateFormat="DD/MM/YYYY"
                                                                                        // required={!isActivity ? false : true}
                                                                                        key={"START_PROJECT"}
                                                                                        value={subList.endDate}
                                                                                        placeholder={t('ระบุวันที่')}
                                                                                        onClear={handleClearDetailDisbursement('endDate', i, index)}
                                                                                        onChange={(e: any) => {
                                                                                            setFormProject((prev) => {
                                                                                                return {
                                                                                                    ...prev,
                                                                                                    tabs: prev.tabs.map((list, mainIndex: number) => {
                                                                                                        if (mainIndex === index) {
                                                                                                            return {
                                                                                                                ...list,
                                                                                                                detailDisbursement: list.detailDisbursement.map((data, detailIndex: number) => {
                                                                                                                    if (detailIndex === i) {
                                                                                                                        return {
                                                                                                                            ...data,
                                                                                                                            endDate: moment(e).format("YYYY-MM-DD")
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        return {
                                                                                                                            ...data
                                                                                                                        }
                                                                                                                    }
                                                                                                                })
                                                                                                            }
                                                                                                        } else {
                                                                                                            return {
                                                                                                                ...list
                                                                                                            }
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            })
                                                                                        }}
                                                                                        allowClear
                                                                                        heading={`งวดที่ ${i + 1} ภายในวันที่`}
                                                                                    />
                                                                                </div>
                                                                                {index === 0 && (
                                                                                    <div className='col-span-12 lg:col-span-2'>
                                                                                        <InputTextField
                                                                                            placeholder='0.00'
                                                                                            // required={!isActivity ? false : true}
                                                                                            disableColor='#FFFAF2'
                                                                                            onkeypress={handleTypingNumber}
                                                                                            onchange={handleChangeDetailDisbursement('budget', i, index)}
                                                                                            value={subList.budget}
                                                                                            heading={t("งบประมาณรวม (บาท)")}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className='col-span-12 lg:col-span-2'>
                                                                                    <InputTextField
                                                                                        placeholder='0.00'
                                                                                        // required={!isActivity ? false : true}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        onchange={handleChangeDetailDisbursement('paid', i, index)}
                                                                                        value={subList.paid}
                                                                                        heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                                    />
                                                                                </div>
                                                                                {index === 0 && (
                                                                                    <div className='col-span-12 lg:col-span-3'>
                                                                                        <InputTextField
                                                                                            placeholder='0.00'
                                                                                            // required={!isActivity ? false : true}
                                                                                            onkeypress={handleTypingNumber}
                                                                                            onchange={handleChangeDetailDisbursement('unpaid', i, index)}
                                                                                            value={subList.unpaid}
                                                                                            heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className='col-span-12 lg:col-span-1 flex justify-start items-end'>
                                                                                    {i === 0 ? (
                                                                                        <ButtonOutlined
                                                                                            onClick={() => handleAddDetailDisbursement(index)}
                                                                                            sx={{ maxWidth: "75px", width: "100%", height: '42px' }}
                                                                                            startIcon={<img src={RouteImage.addButton} alt="add" />}
                                                                                        >
                                                                                            <Typography className='text-primary' variant='body1'>
                                                                                                {t("BUTTON.ADD")}
                                                                                            </Typography>
                                                                                        </ButtonOutlined>
                                                                                    ) : (
                                                                                        <ButtonOutlinedDanger
                                                                                            onClick={() => handleDeleteDetailDisbursement(i, index)}
                                                                                            sx={{ maxWidth: "97px", width: "100%", height: '42px' }}
                                                                                            startIcon={<img src={RouteImage.delete} alt="delete-icon" />}
                                                                                        >
                                                                                            <Typography className='text-danger' variant='body1'>
                                                                                                {t("BUTTON.DELETE_ONCE")}
                                                                                            </Typography>
                                                                                        </ButtonOutlinedDanger>
                                                                                    )}
                                                                                </div>
                                                                                {index === 0 ? <div className='col-span-2'></div> : <div className='col-span-6'></div>}
                                                                            </motion.div>
                                                                        ))}
                                                                    </div>
                                                                </DetailAccordion>
                                                            </MainAccordion>
                                                        </div>
                                                    </article>
                                                </section>


                                                {/* แหล่งงงบประมาณ  👇 */}
                                                {index === 0 && (
                                                    <section className='w-full mt-2'>
                                                        <MainAccordion defaultExpanded>
                                                            <TopicAccordion
                                                                expandIcon={<Dropdown />}
                                                            >
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text={t("แหล่งงบประมาณ")}
                                                                />
                                                            </TopicAccordion>
                                                            <DetailAccordion>
                                                                {list.detailBudget?.map((budget, i: number) => (
                                                                    <div key={i}>
                                                                        <article className='grid grid-cols-12 mt-2'>
                                                                            <div className='col-span-12 lg:col-span-4'>
                                                                                <AutocompleteSelect
                                                                                    // onInvalid={() => validateForm()}
                                                                                    required
                                                                                    // helperText={errorMessageText.ID_BUDGET}
                                                                                    heading={t("แหล่งที่มาของงบประมาณ")}
                                                                                    labelId="label-budget-source"
                                                                                    options={filterActiveOptions(budgetSource, 'budgetStatus', 'idBudget', [budget?.idBudget])}
                                                                                    getOptionLabel={(option: any) => option?.budgetName || ''}
                                                                                    isOptionEqualToValue={(option: any, value: any) => option?.idBudget === value?.idBudget}
                                                                                    value={budgetSource?.find((list: any) => list?.idBudget === budget?.idBudget) || null}
                                                                                    onChange={(_, value: any) => handleChangeIdBudget(i, index)(value?.idBudget)}
                                                                                />
                                                                            </div>
                                                                        </article>
                                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    onblur={handleChangeBudget('sumBudget', i, index, true)}
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.projectBudget}
                                                                                    onchange={handleChangeBudget('projectBudget', i, index)}
                                                                                    heading={t("งบประมาณโครงการ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    onblur={handleChangeBudget('sumBudget', i, index, true)}
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.equipmentBudget}
                                                                                    onchange={handleChangeBudget('equipmentBudget', i, index)}
                                                                                    heading={t("งบประมาณครุภัณฑ์ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    onblur={handleChangeBudget('sumBudget', i, index, true)}
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.extraBudget}
                                                                                    onchange={handleChangeBudget('extraBudget', i, index)}
                                                                                    heading={t("เงินโอนเพิ่มงบประมาณ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    onblur={handleChangeBudget('sumBudget', i, index, true)}
                                                                                    placeholder='0.00'
                                                                                    onkeypress={handleTypingNumber}
                                                                                    required
                                                                                    value={budget?.reducedBudget}
                                                                                    onchange={handleChangeBudget('reducedBudget', i, index)}
                                                                                    heading={t("เงินโอนลดงบประมาณ (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                <InputTextField
                                                                                    placeholder='0.00'
                                                                                    style={{ backgroundColor: "#FFFAF2" }}
                                                                                    required
                                                                                    value={budget.sumBudget || numberFormat((revertFormatCurrency(budget.equipmentBudget.toString()) + revertFormatCurrency(budget.projectBudget.toString()) + revertFormatCurrency(budget.extraBudget.toString())) - revertFormatCurrency(budget.reducedBudget.toString()))}
                                                                                    onchange={handleChangeBudget('sumBudget', i, index)}
                                                                                    heading={t("งบประมาณรวม (บาท)")}
                                                                                />
                                                                            </span>
                                                                            <span className=' col-span-12 lg:col-span-2 self-end'>
                                                                                {i === 0 ? (
                                                                                    <ButtonOutlined
                                                                                        onClick={() => handleAddBudget(index)}
                                                                                        sx={{ maxWidth: "75px", width: "100%", height: '42px' }}
                                                                                        startIcon={<img className='max-w-20' src={RouteImage.addButton} />}
                                                                                    >
                                                                                        <Typography className='text-primary' variant='body1'>
                                                                                            {t("BUTTON.ADD")}
                                                                                        </Typography>
                                                                                    </ButtonOutlined>
                                                                                ) : (
                                                                                    <ButtonOutlinedDanger
                                                                                        onClick={() => handleDeleteBudget(i, index)}
                                                                                        sx={{ maxWidth: "97px", width: "100%", height: '42px' }}
                                                                                        startIcon={<img src={RouteImage.delete} />}
                                                                                    >
                                                                                        <Typography className='text-danger' variant='body1'>
                                                                                            {t("BUTTON.DELETE_ONCE")}
                                                                                        </Typography>
                                                                                    </ButtonOutlinedDanger>
                                                                                )}
                                                                            </span>
                                                                        </article>
                                                                        {/* <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                    <div className='col-span-12'>
                                                                        <InputTextField
                                                                            required
                                                                            onchange={handleChangeRemark('remark', i, index)}
                                                                            value={budget?.remark}
                                                                            heading={t("หมายเหตุ (แหล่งที่มาของงบประมาณ)")}
                                                                        />
                                                                    </div>
                                                                </article> */}
                                                                    </div>
                                                                ))}
                                                            </DetailAccordion>
                                                        </MainAccordion>

                                                    </section>
                                                )}

                                                {/* งบประมาณรวม  👇 */}
                                                <section className='w-full mt-2'>
                                                    {index === 0 && (
                                                        <article className='grid grid-cols-12 gap-2 mt-2'>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#FFFAF2'
                                                                    // value={
                                                                    //     `${numberFormat(formProject.tabs.reduce((total, tab) => total + tab.detailBudget.reduce((a, b) => a + (revertFormatCurrency(b.equipmentBudget.toString()) + revertFormatCurrency(b.extraBudget.toString()) + revertFormatCurrency(b.projectBudget.toString()) - revertFormatCurrency(b.reducedBudget.toString())), 0), 0))}` ||
                                                                    //     `${formatCurrencyData(formProject.tabs[0]?.detailBudget.reduce((x: any, y: any) => x + formatCurrencyData(y.sumBudget.toString(), 'convert'), 0).toString(), 'revert')}`
                                                                    // }
                                                                    value={
                                                                        `${numberFormat(formProject.tabs.reduce((total, tab) => total + tab.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.budget.toString()), 0), 0))}` ||
                                                                        `${formatCurrencyData(formProject.tabs[0]?.detailBudget.reduce((x: any, y: any) => x + formatCurrencyData(y.sumBudget.toString(), 'convert'), 0).toString(), 'revert')}`
                                                                    }
                                                                    // value={`${numberFormat(subAllBudget || '')}`}
                                                                    heading={t("งบประมาณรวม (บาท)")}
                                                                />
                                                            </span>
                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#FFEFEE'
                                                                    value={
                                                                        index === 0 ?
                                                                            `${numberFormat(formProject.tabs.reduce((total, tab) => total + tab.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.paid.toString()), 0), 0))}`
                                                                            :
                                                                            `${numberFormat(list?.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.paid.toString()), 0))}`
                                                                    }
                                                                    heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                />
                                                            </span>

                                                            <span className='col-span-12 lg:col-span-2 self-end'>
                                                                <InputTextField
                                                                    disabled
                                                                    disableColor='#ECF4FC'
                                                                    value={
                                                                        index === 0 ?
                                                                            `${numberFormat(formProject?.tabs.reduce((total, tab) => total + tab.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.unpaid.toString()), 0), 0))}`
                                                                            :
                                                                            `${numberFormat(list?.detailDisbursement.reduce((a, b) => a + revertFormatCurrency(b.unpaid.toString()), 0))}`
                                                                    }
                                                                    heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                />
                                                            </span>
                                                        </article>
                                                    )}


                                                    {list.detailResponsible.map((responsible, i: number) => (
                                                        <>
                                                            <article key={i} className='grid grid-cols-12 gap-2 mt-2'>
                                                                <span className='col-span-12 lg:col-span-10 self-end'>
                                                                    <AutocompleteSelect
                                                                        required
                                                                        heading={`ผู้รับผิดชอบโครงการ${i === 0 ? 'หลัก' : 'ย่อย'}`}
                                                                        getOptionLabel={(option: any) => `${option?.employeeFirstname} ${option?.employeeLastname}`}
                                                                        labelId='EMPLOYEE'
                                                                        loading={keywordLoading}
                                                                        isOptionEqualToValue={(option: any, value: any) => option?.idEmployee === value?.idEmployee}
                                                                        value={employees?.find((list: any) => responsible.idEmployee === list?.idEmployee) || null}
                                                                        onChange={(e, value) => {
                                                                            setFormProject((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    tabs: prev.tabs.map((tab, mainIndex: number) => {
                                                                                        if (mainIndex === index) {
                                                                                            return {
                                                                                                ...tab,
                                                                                                detailResponsible: tab.detailResponsible.map((data, detailIndex: number) => {
                                                                                                    if (i === detailIndex) {
                                                                                                        return {
                                                                                                            ...data,
                                                                                                            idEmployee: value?.idEmployee
                                                                                                        }
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...data
                                                                                                        }
                                                                                                    }
                                                                                                })
                                                                                            }
                                                                                        } else {
                                                                                            return {
                                                                                                ...tab
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                }
                                                                            })
                                                                        }}
                                                                        options={filterActiveOptions(employees, 'employeeStatus', 'idEmployee', [responsible?.idEmployee])}
                                                                    />
                                                                </span>
                                                                <span className='col-span-6 lg:col-span-2'>
                                                                    <InputTextField
                                                                        disabledAutoComplete
                                                                        onkeypress={handleTypingNumber}
                                                                        required
                                                                        onchange={handleChangeDetailResponsible('percent', i, index)}
                                                                        value={responsible?.percent}
                                                                        heading={t("สัดส่วนที่รับผิดชอบ (%)")}
                                                                    />
                                                                </span>
                                                            </article>
                                                            <article className='w-full flex justify-start lg:justify-end items-center mt-2'>
                                                                <div className='w-auto'>
                                                                    {i === 0 ? (
                                                                        <ButtonOutlined
                                                                            onClick={() => handleAddDetailResponsible(index)}
                                                                            sx={{ maxWidth: "75px", width: "100%", height: '42px' }}
                                                                            startIcon={<img className='max-w-20' src={RouteImage.addButton} />}
                                                                        >
                                                                            <Typography className='text-primary' variant='body1'>
                                                                                {t("BUTTON.ADD")}
                                                                            </Typography>
                                                                        </ButtonOutlined>
                                                                    ) : (
                                                                        <ButtonOutlinedDanger
                                                                            onClick={() => handleDeleteDetailResponsible(i, index)}
                                                                            sx={{ maxWidth: "97px", width: "100%", height: '42px' }}
                                                                            startIcon={<img src={RouteImage.delete} />}
                                                                        >
                                                                            <Typography className='text-danger' variant='body1'>
                                                                                {t("BUTTON.DELETE_ONCE")}
                                                                            </Typography>
                                                                        </ButtonOutlinedDanger>
                                                                    )}
                                                                </div>
                                                            </article>
                                                        </>
                                                    ))}


                                                    <article className='grid grid-cols-12 mt-2'>
                                                        <div className='col-span-12'>
                                                            <InputTextField
                                                                size='medium'
                                                                value={list.projectDesc}
                                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                                    setFormProject((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            tabs: prev.tabs.map((list, mainIndex: number) => {
                                                                                return mainIndex === index ? { ...list, projectDesc: e.target.value } : { ...list }
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                                heading={t("รายละเอียดโครงการ")}
                                                            />
                                                        </div>
                                                    </article>
                                                </section>

                                                {/* ตัวชี้วัดประเมินผลโครงการ  👇 */}
                                                <article className='w-full mt-8'>
                                                    <div className='w-full'>
                                                        <Typography className='text-primary' variant='h4'>
                                                            {t("ตัวชี้วัดประเมินผลโครงการ")}
                                                        </Typography>
                                                    </div>

                                                    {/* TABS */}
                                                    <section className='w-full mt-2'>
                                                        <Box className='flex flex-col justify-start items-start gap-2 md:flex-row md:justify-between md:items-end'>
                                                            <Tabs
                                                                TabIndicatorProps={{ sx: { backgroundColor: colors.white } }}
                                                                value={indicatorTabs}
                                                                onChange={handleChangeIndicatorTabs}
                                                                aria-label="indicators-tabs">
                                                                {list.detailIndicators.map((list, i: number) => (
                                                                    <CustomTab
                                                                        label={
                                                                            <div>
                                                                                <Typography>{`ตัวชี้วัดเรื่องที่ ${i + 1}`}</Typography>
                                                                                {i !== 0 && (
                                                                                    <button onClick={(e) => {
                                                                                        handleDeleteTabsIndicator(i, index)
                                                                                        setIndicatorTabs(i - 1)
                                                                                    }} className='absolute top-0 right-0'>
                                                                                        <HighlightOffOutlinedIcon className='scale-75' />
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        }  {...indicatorTabsProps(i)} />
                                                                ))}
                                                            </Tabs>
                                                            <span className='w-auto'>
                                                                <ButtonOutlined
                                                                    onClick={() => handleAddIndicator(index)}
                                                                    startIcon={<img src={RouteImage.addForm} alt='add-icon' />}
                                                                    sx={{
                                                                        borderRadius: "6px 6px 0 0", height: "42px", border: `1px solid ${colors.borderInput}`
                                                                    }}>
                                                                    <Typography className='text-primary'>{"เพิ่มตัวชี้วัด"}</Typography>
                                                                </ButtonOutlined>
                                                            </span>
                                                        </Box>

                                                        <Box className='bg-bg_secondary w-full mt-2'>
                                                            {list && list.detailIndicators.map((indicator, indexDetail: number) => (
                                                                <IndicatorCustomTabPanel value={indicatorTabs} index={indexDetail}>
                                                                    <>
                                                                        <article className='grid grid-cols-12 gap-2'>
                                                                            <span className='col-span-12 lg:col-span-10'>
                                                                                <AutocompleteSelect
                                                                                    noOptionsText={t("ไม่พบข้อมูล")}
                                                                                    freeSolo
                                                                                    loading={keywordLoading}
                                                                                    required={index === 0}
                                                                                    heading={`เรื่อง`}
                                                                                    onInputChange={(e, newValue) => {
                                                                                        debouncedApiCall({ searchItem: newValue, setItem: setKeywordIndicator })
                                                                                        handleAutocompleteChangeIndicator('indicatorsName', newValue, indexDetail, index)
                                                                                        handleAutocompleteChangeIndicator('idIndicators', null, indexDetail, index)
                                                                                        const indicatorIdCheck: number = indicators?.find((list: any) => list?.indicatorsName === newValue)?.idIndicators
                                                                                        if (indicatorIdCheck) {
                                                                                            handleAutocompleteChangeIndicator('idIndicators', indicatorIdCheck, indexDetail, index)
                                                                                        }
                                                                                    }}
                                                                                    inputValue={indicator.indicatorsName}
                                                                                    getOptionLabel={(option: any) => `${option?.indicatorsName}`}
                                                                                    labelId='INDICATOR_NAME'
                                                                                    value={indicators && indicators?.find((list: any) => indicator?.idIndicators === list?.idIndicators)}
                                                                                    onChange={(e, value) => handleAutocompleteChangeIndicator('idIndicators', value?.idIndicators, indexDetail, index)}
                                                                                    options={indicators || []}
                                                                                />
                                                                            </span>
                                                                            <span className='col-span-12 lg:col-span-2'>
                                                                                <InputTextField
                                                                                    disabledAutoComplete
                                                                                    required={index === 0}
                                                                                    onchange={handleChangeIndicatorActivities('percent', indexDetail, index)}
                                                                                    onkeypress={handleTypingNumber}
                                                                                    value={indicator?.percent}
                                                                                    heading={t("สัดส่วน (%)")}
                                                                                />
                                                                            </span>
                                                                        </article>
                                                                        <article className='w-full mt-3'>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 1' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('min1', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min1}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('max1', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max1}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        onchange={handleChangeIndicatorActivities('description1', indexDetail, index, true)}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description1}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>

                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 2' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('min2', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min2}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('max2', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max2}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        onchange={handleChangeIndicatorActivities('description2', indexDetail, index, true)}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description2}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>

                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 3' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('min3', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min3}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('max3', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max3}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        onchange={handleChangeIndicatorActivities('description3', indexDetail, index, true)}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description3}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 4' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('min4', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min4}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('max4', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max4}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        onchange={handleChangeIndicatorActivities('description4', indexDetail, index, true)}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description4}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                            <LabelCustom className='w-full mt-3' variant='h6' text='Level 5' />
                                                                            <Box className="grid grid-cols-12 gap-x-2 gap-y-3">
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('min5', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.min5}
                                                                                        heading={t("ค่าเริ่มต้น")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-6 lg:col-span-2 self-end'>
                                                                                    <InputTextField
                                                                                        required={index === 0}
                                                                                        onchange={handleChangeIndicatorActivities('max5', indexDetail, index)}
                                                                                        onkeypress={handleTypingNumber}
                                                                                        placeholder='0.00'
                                                                                        value={indicator?.max5}
                                                                                        heading={t("ค่าสูงสุด")}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-span-12 lg:col-span-4 self-end'>
                                                                                    <InputTextField
                                                                                        onchange={handleChangeIndicatorActivities('description5', indexDetail, index, true)}
                                                                                        placeholder='ระบุหมายเหตุ'
                                                                                        value={indicator.description5}
                                                                                        heading={t("คำอธิบาย")}
                                                                                    />
                                                                                </span>
                                                                            </Box>
                                                                        </article>
                                                                    </>
                                                                </IndicatorCustomTabPanel>
                                                            ))}

                                                        </Box>
                                                    </section>
                                                </article>

                                            </CustomTabPanel>
                                        ))}


                                        {/* ))} */}
                                    </div>
                                </Box>
                            </article>

                        </motion.section>
                    </form>
                </styled.Content>
            </styled.MainContainer>
        </styled.ContainerHome>
    )
}

export default CreateProjectInformation